import React from "react";

const View = () => {
  return (
    <div>
      <span>Test View Page</span>
    </div>
  );
};

export default View;
